/** Formats a latitude per spec §8.3: "52,5° N" (DE, comma) / "33.9° S" (EN, point). */
export function formatLatitude(lat, lang) {
    const hemisphere = lat >= 0 ? "N" : "S";
    const abs = Math.abs(lat);
    const rounded = Math.round(abs * 10) / 10;
    const numStr = lang === "de" ? rounded.toFixed(1).replace(".", ",") : rounded.toFixed(1);
    return `${numStr}° ${hemisphere}`;
}
//# sourceMappingURL=latitude.js.map